import Product1 from '../../assets/images/product/product-1.jpg';
import Product2 from '../../assets/images/product/product-2.jpg';
import Product3 from '../../assets/images/product/product-3.jpg';
import Product4 from '../../assets/images/product/product-4.jpg';
import Product5 from '../../assets/images/product/product-5.jpg';
import Product6 from '../../assets/images/product/product-6.jpg';
import Product7 from '../../assets/images/product/product-7.jpg';


export const ProductListdata=[
 {
     images:Product1,
     title:'Oculus VR',
     reference:'Reference 1204',
     time:'20h:46m:30s',
     price:'$149',
     rating:'4.5',
     ratingnumber:'(145)'
 },
 {
    images:Product2,
    title:'Wall Clock ',
    reference:'Reference 1004',
    time:'20h:46m:30s',
    price:'$399',
    rating:'3.5',
    ratingnumber:'(77)'
 },
 {
    images:Product3,
    title:'Note Diaries ',
    reference:'Reference 1224',
    time:'20h:46m:30s',
    price:'$49',
    rating:'3.5',
    ratingnumber:'(98)'
 },
 {
     images:Product4,
     title:'Flower Port',
     reference:'Reference 1414',
     time:'18h:46m:30s',
     price:'$199',
     rating:'4.5',
     ratingnumber:'(1455)'
 },
 {
    images:Product5,
    title:'School Bag ',
    reference:'Reference 1000',
    time:'03h:30m:30s',
    price:'$99',
    rating:'4.5',
    ratingnumber:'(145)'
 },
 {
    images:Product6,
    title:'Rado Watch ',
    reference:'Reference 9204',
    time:'20h:46m:30s',
    price:'$594',
    rating:'4.5',
    ratingnumber:'(1245)'
 },
 {
    images:Product7,
    title:'Traveling Bag',
    reference:'Reference 1155',
    time:'20h:46m:30s',
    price:'$49',
    rating:'4.5',
    ratingnumber:'(1045)'
 }
]